import React from 'react'
import Box from '@mui/material/Box';
import { Backdrop } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import { useTreeItem2Utils } from '@mui/x-tree-view/hooks';
import Typography from '@mui/material/Typography';
import { TreeItem2 } from '@mui/x-tree-view/TreeItem2';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import ApartmentIcon from '@mui/icons-material/Apartment';
import Icon from '@mui/material/Icon';
import PropTypes from 'prop-types';
import imagePlaceholder from '../../../assets/images/No-Image-Placeholder.svg';
import { agcColours } from '../../../helpers/colourHelper';
import { InfoTooltip } from '../../../components/CustomStyles/StyledComponents';
import { useBreakpoint, isMobileDevice } from '../../../helpers/breakpointsHelper';

function OrgLabel({ children, className, logoURL, type, userCount, farmCount, officeCount }) {
    const breakpoint = useBreakpoint();
    const isMobile = isMobileDevice(breakpoint);
    const logoMax = { maxHeight: '1.5em', maxWidth: '1.5em',verticalAlign: 'middle' }
    const txt2IconSpacer = {
        height: '0.5em', 
        width: isMobile? '1.2em':'0.5em',
        verticalAlign: 'middle'}

    return (
        <Box className={className}>
            <InfoTooltip title={logoURL ? '' : 'Contact Agrecalc to add your logo'}>
                <Box component="img" sx={logoMax}
                    alt={`${className} Logo`}
                    src={logoURL || imagePlaceholder} />
            </InfoTooltip>
            <Typography component="span" sx={{ maxWidth: '70%', verticalAlign: 'middle' }} > {children}</Typography>
            {
             // Icon Component here is to make a small space between the name and the icons
             // In small screens (mobile devices) we put the inons on separate line 
             isMobile && <br/>
            }
            <Icon component="span" sx={txt2IconSpacer} />
            {type === 'organisation' &&
                <Box component="span" sx={{ pr: 1 }}>
                    <InfoTooltip title='Offices'>
                        <ApartmentIcon id='office' sx={{ maxHeight: '0.75em', maxWidth: '0.75em', verticalAlign: 'middle', color: agcColours.AgrecalcPetroleum }} />
                    </InfoTooltip>
                    <Typography component="span" sx={{ maxWidth: '10%', verticalAlign: 'middle', color: agcColours.AgrecalcPetroleum }} > {Number.isFinite(officeCount) ? officeCount : '?'} </Typography>
                </Box>
            }
            <Box component="span" sx={{ pr: 1 }}>
                <InfoTooltip title='Users'>
                    <PeopleAltOutlinedIcon id='office' sx={{ maxHeight: '0.75em', maxWidth: '0.75em', verticalAlign: 'middle', color: agcColours.MilanoRed }} />
                </InfoTooltip>
                <Typography component="span" sx={{ maxWidth: '10%', verticalAlign: 'middle', color: agcColours.MilanoRed }} > {Number.isFinite(userCount) ? userCount : '?'} </Typography>
            </Box>
            <Box component="span">
                <InfoTooltip title='Farms'>
                    <AgricultureIcon id='office' sx={{ maxHeight: '0.75em', maxWidth: '0.75em', verticalAlign: 'middle', color: agcColours.AgrecalcGreen }} />
                </InfoTooltip>
                <Typography component="span" sx={{ maxWidth: '10%', verticalAlign: 'middle', color: agcColours.AgrecalcGreen }} > {Number.isFinite(farmCount) ? farmCount : '?'} </Typography>
            </Box>

        </Box>
    );
}

const OrgTreeItem = React.forwardRef(function CustomTreeItem(props, ref) {
    const { publicAPI } = useTreeItem2Utils({
        itemId: props.itemId,
        children: props.children,
    });

    const item = publicAPI.getItem(props.itemId);

    return (
        <TreeItem2 {...props} ref={ref}
            slots={{ label: OrgLabel, }}
            slotProps={{
                label: {
                    logoURL: item?.logoURL || '', type: item?.type,
                    userCount: item?.userCount, farmCount: item?.farmCount, officeCount: item?.officeCount
                },
            }}
        />
    );
});

OrgTreeItem.propTypes = {
    itemId: PropTypes.string,
    children: PropTypes.object,
};

export const OrgTreeView = ({ treeData, page, rowsPerPage, onSelectedItemsChange, selectedItems, disable }) => {
    let startElem = page * rowsPerPage;
    let endElem = startElem + rowsPerPage;
    return (
        <Box sx={{
            minHeight: 110, flexGrow: 1, maxWidth: '100%',
            overflowY: disable ? "clip" : "scroll", maxHeight: 500, position: 'relative'
        }} >
            <RichTreeView items={treeData?.slice(startElem, endElem) || []}
                multiSelect={false} slots={{ item: OrgTreeItem }}
                onSelectedItemsChange={onSelectedItemsChange}
                selectedItems={selectedItems}
                disableSelection={disable}
            />
            <Backdrop open={disable} style={{ position: 'absolute' }}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </Box>
    );
}

OrgTreeView.propTypes = {
    treeData: PropTypes.array,
    page: PropTypes.number,
    rowsPerPage: PropTypes.number,
    onSelectedItemsChange: PropTypes.func,
    disable: PropTypes.bool,
    selectedItems:PropTypes.any
};